import { render, staticRenderFns } from "./exhibition-info-wrapper.vue?vue&type=template&id=c675efe0&scoped=true&"
import script from "./exhibition-info-wrapper.vue?vue&type=script&lang=js&"
export * from "./exhibition-info-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-info-wrapper.vue?vue&type=style&index=0&id=c675efe0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c675efe0",
  null
  
)

export default component.exports